/**
 * Helpers for Universal Descriptor (UD) mode on Operating Points.
 * Tag data values are matched by UniversalDescriptorId on each parameter (from taggroups API).
 *
 * List rows match {@link UniversalDescriptor} from `getUniversalDescriptors` (normalized:
 * `FriendlyName`, `UD`, `UniversalDescriptorId`, `IsActive`; wire `TagName` is not exposed).
 *
 * @typedef {Object} UniversalDescriptor
 * @property {number} UniversalDescriptorId
 * @property {string} UD
 * @property {string} FriendlyName
 * @property {boolean} IsActive
 */

/**
 * Active universal descriptors for the Add/Edit column picker.
 *
 * @param {UniversalDescriptor[]} descriptors
 * @returns {Array<{ universalDescriptorId: number, UD: string }>}
 */
export function getActiveDescriptorsForOperatingPointsPicker(descriptors) {
  return descriptors
    .filter((d) => d.IsActive !== false)
    .map((d) => ({
      universalDescriptorId: d.UniversalDescriptorId,
      UD: String(d.FriendlyName).trim(),
    }))
    .sort((a, b) => a.UD.localeCompare(b.UD));
}
